import React from "react";
import { Box, Typography } from "@mui/material";
import { formatAssessmentScoreFeedback } from "../../../utils/assessmentScore";

interface AssessmentScoreFeedbackProps {
  score: number;
  bonusScore?: number;
  justification?: string | null;
}

export const AssessmentScoreFeedback: React.FC<AssessmentScoreFeedbackProps> = ({
  score,
  bonusScore = 0,
  justification,
}) => {
  const hasPositiveScore = score > 0;

  return (
    <Box
      sx={{
        mt: 3,
        p: 3,
        borderRadius: "8px",
        backgroundColor: hasPositiveScore ? "#66EF64B2" : "#DD503E",
        color: hasPositiveScore ? "inherit" : "#FFFFFF",
        border: `1px solid ${hasPositiveScore ? "#66EF64" : "#DD503E"}`,
      }}
    >
      <Typography variant="body2" sx={{ fontSize: "16px", mb: justification ? 2 : 0 }}>
        <Box component="span" sx={{ fontWeight: 700, fontStyle: "italic" }}>
          {formatAssessmentScoreFeedback(score, bonusScore)}
        </Box>
      </Typography>

      {justification ? (
        <Box
          sx={{
            pt: 1.5,
            borderTop: `1px solid ${
              hasPositiveScore ? "rgba(0, 0, 0, 0.1)" : "rgba(255, 255, 255, 0.3)"
            }`,
          }}
        >
          <Typography
            variant="body2"
            sx={{
              fontWeight: 600,
              mb: 1,
              fontSize: "14px",
              opacity: 0.9,
            }}
          >
            Feedback:
          </Typography>
          <Typography
            variant="body2"
            sx={{
              fontSize: "14px",
              lineHeight: 1.6,
              whiteSpace: "pre-wrap",
            }}
          >
            {justification}
          </Typography>
        </Box>
      ) : null}
    </Box>
  );
};
